import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import Common from "@/common";
// import VideoPlayer from "@/components/VideoPlayer";

export const cardToCardMixin = {
  data() {
    return {
      showVideo: false,
      videoAddress: require("/src/assets/videos/payInstruction.mp4"),
      creditCardLastFourNumbers: "",
      paymentId: "",
      captchaInput: "",
      imageBase64: "",
      captchaKey: "",
      getCaptchaImagePending: false,
      receiverCreditCardNumber: "",
      amountValue: null,
      receiverName: "",
      creditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      secondContainerVisibility: false,
      bankImageSource: "",
      checkIfInputNotEmpty: false,
      offlineAccountList: [],
      selectedAccount: null,
      copyToClipboardResult: false,
      copyToClipboardFailed: false,
      shetabOfflineAmounts: null,
    };
  },
  computed: {
    ...mapGetters([
      "getStepperPage",
      "getIsCompName",
      "getVersion",
      "getPayingAmount",
      "getCompleteCreditCardNumber",
      "isCreditCardReceivedFromServer",
      "isShetabAmountsReceivedFromServer",
      "getOfflineCards",
      "getSitesApiResult",
    ]),
    getSiteId17Condition() {
      return Common.siteId17Condition;
    },
    formattedReceiverCreditCardNumber() {
      return this.$options.filters.creditCardSep(this.receiverCreditCardNumber);
    },
  },
  watch: {
    creditCardInfo: {
      handler(val) {
        [this.checkIfInputNotEmpty, this.bankImageSource] =
          Common.checkWhatBank(this.creditCardInfo);
        const enteredCardNum =
          val[0].value + val[1].value + val[2].value + val[3].value;

        //checking credit card number validation
        if (enteredCardNum.length <= 16 && enteredCardNum.length > 0) {
          this.secondContainerVisibility =
            this.validateCreditCardNumber(enteredCardNum);
        }
      },
      deep: true,
    },
    creditCardLastFourNumbers(value) {
      if (value.length > 3) {
        document.getElementById("captchaInput").focus();
      }
    },
    amountValue(value) {
      // if the user selected an value, there is no need to add comma sep
      // this should only work for single input value
      if (this.shetabOfflineAmounts && !this.isShetabAmountsReceivedFromServer)
        return;
      let newVal = value;
      newVal = String(value).replaceAll(",", "");
      this.amountValue = this.$options.filters.commaSep(newVal);
    },
  },
  methods: {
    ...mapMutations(["setIsCompName", "setStepperPage"]),
    openVideoPlayer() {
      setTimeout(() => {
        this.showVideo = !this.showVideo;
      }, 50);
    },
    goPageBack() {
      this.$router.go(-1);
    },
    copyToClipboard() {
      let textValue = document.querySelector("#receiverCreditCardNumber");
      textValue.setAttribute("type", "text");
      textValue.select();
      // Error Handling If Copying was not Successful
      try {
        this.copyToClipboardResult = document.execCommand("copy");
        alertHelper.successAlert("", "شماره کارت کپی شد");
      } catch (err) {
        this.copyToClipboardFailed = true;
        alertHelper.errorAlert("", "مشکل در کپی کردن شماره کارت!!", 1000);
      }
    },
    handleCreditCardImageSource(cardNum) {
      const firstSixDigits = cardNum.toString().substring(0, 6);
      if (firstSixDigits === "505416") {
        return require("@/assets/images/gardesh-gari-offline-card.png");
      }
      return require("@/assets/images/creditCardImg.png");
    },
    selectAccount(account, page) {
      this.selectedAccount = account;
      this.setStepperPage(page);
    },
    validateCreditCardNumber(number) {
      let sum = 0;
      const numericList = number.split("");
      for (let index = 1; index <= numericList.length; index++) {
        //if it was the last number (since its position is always 16), it will multiply by 1 anyway in the loop but this also works.
        if (index === numericList.length) {
          sum = +numericList[index - 1] + sum;
          //if even number
        } else if (index % 2 === 0) {
          let result = numericList[index - 1] * 1;
          result = result > 9 ? result - 9 : result;
          sum = result + sum;
        } else {
          let result = numericList[index - 1] * 2;
          result = result > 9 ? result - 9 : result;
          sum = result + sum;
        }
      }
      if (numericList.length === 16) {
        return sum % 10 === 0;
      }
    },
    handleOfflineAccountBankName(account) {
      if (account["bank-names"] === "GARDESHGARI") {
        return this.$translate("gardeshgari");
      } else if (account["bank-names"] === "REFAH") {
        return this.$translate("refah");
      } else if (account["bank-names"].toLowerCase() === "keshavarzi") {
        return this.$translate("keshavarzi");
      } else if (account["bank-names"].toLowerCase() === "tejarat") {
        return this.$translate("tejarat");
      } else if (account["bank-names"].toLowerCase() === "sepah") {
        return this.$translate("sepah");
      } else if (account["bank-names"].toLowerCase() === "saman") {
        return this.$translate("saman");
      } else {
        return account["bank-names"].toLowerCase();
      }
    },
    handleCardImage(account) {
      if (account["bank-names"] === "GARDESHGARI") {
        return require("@/assets/images/creditCardImg.png");
      } else if (account["bank-names"] === "REFAH") {
        return require("@/assets/images/creditCardImg.png");
      } else if (account["bank-names"].toLowerCase() === "keshavarzi") {
        return require("@/assets/images/keshavarzi-card-image.png");
      } else if (account["bank-names"].toLowerCase() === "tejarat") {
        return require("@/assets/images/tejarat-card-image.png");
      } else if (account["bank-names"].toLowerCase() === "sepah") {
        return require("@/assets/images/sepah-card-image.png");
      } else {
        return require("@/assets/images/creditCardImg.png");
      }
    },
    handleOfflineAccountBankLogo(account) {
      if (account["bank-names"] === "GARDESHGARI") {
        return require("@/assets/images/gardeshgari.png");
      } else if (account["bank-names"] === "REFAH") {
        return require("@/assets/images/refah-logo.png");
      } else if (account["bank-names"].toLowerCase() === "keshavarzi") {
        return require("@/assets/images/bankImages/keshavarzi.png");
      } else if (account["bank-names"].toLowerCase() === "melli") {
        return require("@/assets/images/bankImages/bankmeli.png");
      } else if (account["bank-names"].toLowerCase() === "tejarat") {
        return require("@/assets/images/bankImages/tejarat.png");
      } else if (account["bank-names"].toLowerCase() === "sepah") {
        return require("@/assets/images/bankImages/sepah.png");
      } else {
        return require("@/assets/images/CardToCardOn.png");
      }
    },
    cancelPayment() {
      let paymentId = this.$route.query.id;
      const callBackUrl = this.getCallBackUrl;
      alertHelper.loadingAlert();
      if (callBackUrl) {
        window.location.href = Common.createCallback(callBackUrl, paymentId, 0);
      } else {
        this.$http.delete(`payments/${paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
            result.data.data.callback_url,
            paymentId,
            0
          );
        });
      }
    },

    clickedOutSideOfVideo() {
      this.showVideo = !this.showVideo;
    },
    onCreditCardPaste(evt, targetVariable) {
      Common.onInfoPaste.call(this, evt, targetVariable);
    },
    useThisCardFromStore(cardInfo) {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        let spiltedCardInfo = cardInfo.match(/.{1,4}/g);
        this.creditCardInfo[i].value = spiltedCardInfo[i];
      }
    },
    filterAccountTransfers(accounts) {
      let accountTransferArray = [];
      accounts.forEach((account) => {
        if (account.is_card_transfer === 1) {
          accountTransferArray.push(account);
        }
      });
      return accountTransferArray;
    },

    getOfflineAccountsList() {
      alertHelper.loadingAlert();
      this.$http.get(`payments/${this.paymentId}/offline-accounts-list`).then(
        (result) => {
          alertHelper.closeAlert();
          const resultData = result.data.data;
          this.offlineAccountList = this.filterAccountTransfers(resultData);
        },
        (error) => {
          alertHelper.apiErrorAlert("", error.body.message);
        }
      );
    },
    /**
     * ##if data was available on the payment component, (from payment api important one)
     * importance level 1
     */
    setFirstImportantData() {
      //if paying amount was available (only one value)
      if (this.getPayingAmount) {
        this.amountValue = this.getPayingAmount;
      }
      if (this.getCompleteCreditCardNumber) {
        this.useThisCardFromStore(this.getCompleteCreditCardNumber);
      }
    },
    getCardNumber() {
      alertHelper.loadingAlert();
      const offlineMinPrice =
        this.getSitesApiResult.data.settings.offline_min_price_info;
      const infoUrl = this.selectedAccount
        ? `payments/${this.paymentId}/offline-shetab?id=${this.selectedAccount.id}`
        : `payments/${this.paymentId}/offline-shetab`;
      this.$http.get(infoUrl).then(
        (result) => {
          const resultData = result.data.data;

          if (+resultData.is_card_transfer === 1) {
            this.receiverCreditCardNumber = resultData.card_number;
          } else if (+resultData.is_card_transfer === 0) {
            return alertHelper.errorAlert(
              "درگاه کارت به کارت فعال نمی‌باشد",
              ""
            );
          }

          // this.receiverCreditCardNumber = resultData.card_number;
          this.receiverName = resultData.name;
          this.setStepperPage("pageThree");
          this.setFirstImportantData();
          this.$swal({
            title: this.getSiteId17Condition()
              ? `حداقل مبلغ خرید برای این روش پرداخت ${
                  offlineMinPrice ?? 100
                } میباشد`
              : "",
            text: "واريزيهايى كه از طريق كيوسك بانكى و پُل انجام ميگيرد قابل شارژ نخواهند بود.\nمبلغ مورد نظر را به شماره کارت نمایش داده شده از طریق همراه بانک یا اپلیکیشن های کارت به کارت واريز نماييد و سپس شماره کارت خود را در کادر مورد نظر وارد کنید",
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "متوجه شدم",
            customClass: {
              title: "alertTitleClass",
            },
            timer: 20000,
          });
        },
        (error) => {
          this.getTetherWalletResult = false;
          alertHelper.apiErrorAlert("", error.body.message);
        }
      );
    },
    getCaptchaImage() {
      let windowHost = "";
      if (window.location.host.includes("localhost"))
        windowHost = "caspian-pay.com";
      else windowHost = window.location.host;
      this.getCaptchaImagePending = true;
      this.$http.get(`https://${windowHost}/captcha/api/math`).then(
        (result) => {
          this.imageBase64 = result.body.img;
          this.captchaKey = result.body.key;
          this.getCaptchaImagePending = false;
        },
        (error) => {
          alertHelper.apiErrorAlert("", error.body.message);
          this.getCaptchaImagePending = false;
        }
      );
    },
    handleAutoFocus(index) {
      if (this.creditCardInfo[index].value.length === 4) {
        const nextIndex = index + 1;
        if (nextIndex < this.creditCardInfo.length) {
          const element = document.getElementById(
            `credit-card-input-key${nextIndex}`
          );
          if (element) {
            this.$nextTick(() => {
              element.focus();
            });
          }
        }
      }
    },
    submitBuyerCardInfo() {
      this.captchaInput = this.$options.filters.englishDigits(
        this.captchaInput
      );
      this.amountValue = this.$options.filters.englishDigits(this.amountValue);
      let creditCardConcated = "";
      for (let i = 0; i < 4; i++) {
        creditCardConcated += this.$options.filters.englishDigits(
          this.creditCardInfo[i].value
        );
      }
      if (this.checkAllInputs()) {
        alertHelper.loadingAlert(
          "لطفا منتظر بمانید و تا زمان مشخص شدن نتیجه تراکنش، این صفحه را رفرش نکنید"
        );
        this.$http
          .post(`transactions`, {
            payment_id: this.paymentId,
            gateway: "SHETAB_OFFLINE",
            captcha: this.captchaInput,
            captcha_key: this.captchaKey,
            last4digit: creditCardConcated,
            amount: parseInt(String(this.amountValue).replaceAll(",", "")),
            destination_account_id: this.selectedAccount
              ? this.selectedAccount.id
              : "",
          })
          .then(
            (result) => {
              this.creditCardConcated = "";
              if (result.status === 201) {
                alertHelper
                  .transactionSuccessAlert(
                    "پرداخت موفق، لطفا این صفحه را نبندید",
                    `Amount: ${this.$options.filters.commaSep(
                      result.data.data.amount
                    )} From: ${result.data.data.from}`,
                    5000
                  )
                  .then(() => {
                    window.location.href = Common.createCallback(
                      result.data.data.payment.callback_url,
                      this.paymentId,
                      1
                    );
                  });
              }
            },
            (error) => {
              this.getCaptchaImage();
              this.creditCardConcated = "";
              if (error.body.code === 6001) {
                alertHelper.apiErrorAlert(
                  "",
                  error.body.message +
                    "لطفا در صورتی که از صحت اطلاعات اطمینان دارید، پس از چند دقیقه دوباره امتحان کنید",
                  12000
                );
              } else {
                alertHelper.apiErrorAlert("", error.body.message);
              }
            }
          );
      }
    },
    isCreditCardInputFilled() {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        if (this.creditCardInfo[i].value.length < 4) {
          return false; // Return false if any value has length less than 4
        }
      }
      return true; // Return true if all values have length greater than or equal to 4
    },
    //Checking if all inputs are filled
    checkAllInputs() {
      if (this.amountValue && this.amountValue.length <= 0) {
        alertHelper.errorAlert("", "لطفا مبلغ را وارد کنید");
        return false;
      } else if (!this.isCreditCardInputFilled()) {
        alertHelper.errorAlert("", "شماره کارت را وارد کنید");
        return false;
      } else if (!this.secondContainerVisibility) {
        alertHelper.errorAlert("", "شماره کارت نا معتبر است");
        return false;
      } else if (this.captchaInput.length <= 0) {
        alertHelper.errorAlert("", "لطفا کد امنیتی را وارد کنید");
        return false;
      } else return true;
    },
    handleShetabOfflineAmountList() {
      const offlineAmounts =
        this.getSitesApiResult.data.settings.shetab_offline_amounts;
      this.shetabOfflineAmounts = offlineAmounts
        ? Common.translateMultiNumberStringForSelector(offlineAmounts)
        : null;
    },
  },
  created() {
    this.setIsCompName("cardToCard");
    this.setStepperPage("pageOne");
    this.paymentId = this.$route.query.id;
    if (!this.paymentId) {
      alertHelper.paymentIdNotValidAlert();
    } else {
      this.handleShetabOfflineAmountList();
      if (this.getOfflineCards && this.getOfflineCards.length > 0) {
        this.offlineAccountList = this.filterAccountTransfers(
          this.getOfflineCards
        );
      } else {
        this.getOfflineAccountsList();
      }
      this.getCaptchaImage();
    }
  },
};
